import BaseComponent from '../base-component/base-component'
import { Nullable } from '../../types/common'

class PriceRange extends BaseComponent {
  minNumberInput: Nullable<HTMLInputElement>
  maxNumberInput: Nullable<HTMLInputElement>
  rangeWrapper: Nullable<HTMLElement>
  minRangeInput: Nullable<HTMLInputElement>
  maxRangeInput: Nullable<HTMLInputElement>
  progress: Nullable<HTMLElement>

  constructor() {
    super()

    this.minNumberInput = this.querySelector(`[data-price-min-range-number]`)
    this.maxNumberInput = this.querySelector(`[data-price-max-range-number]`)
    this.rangeWrapper = this.querySelector(`[data-price-range-inputs-wrapper]`)
    this.minRangeInput = this.querySelector(`[data-price-min-range-input]`)
    this.maxRangeInput = this.querySelector(`[data-price-max-range-input]`)
    this.progress = this.querySelector(`[data-price-range-progress]`)
  }

  connectedCallback(): void {
    if (this.minRangeInput) {
      this.updateMinRangeInput(+this.minRangeInput.value)
    }

    if (this.maxRangeInput) {
      this.updateMaxRangeInput(+this.maxRangeInput.value)
    }

    this.minNumberInput.addEventListener('input', this.handleNumberChange)
    this.maxNumberInput.addEventListener('input', this.handleNumberChange)

    this.minRangeInput.addEventListener('input', this.handleRangeChange)
    this.maxRangeInput.addEventListener('input', this.handleRangeChange)

    this.rangeWrapper.addEventListener('mouseenter', this.handleRangeInput)
    this.rangeWrapper.addEventListener('mousemove', this.handleRangeInput)
  }

  disconnectedCallback(): void {
    this.minNumberInput.removeEventListener('input', this.handleNumberChange)
    this.maxNumberInput.removeEventListener('input', this.handleNumberChange)

    this.minRangeInput.removeEventListener('input', this.handleRangeChange)
    this.maxRangeInput.removeEventListener('input', this.handleRangeChange)

    this.rangeWrapper.removeEventListener('mouseenter', this.handleRangeInput)
    this.rangeWrapper.removeEventListener('mousemove', this.handleRangeInput)
  }

  handleRangeInput = (event: MouseEvent): void => {
    const maxInput = this.querySelector(`[data-price-range-max-input]`)
    const minInput = this.querySelector(`[data-price-range-min-input]`)

    if (this.progress && minInput && maxInput) {
      const middleOfProgress =
        this.progress.offsetLeft + this.progress.offsetWidth / 2
      const isMinInputClosest = event.offsetX < middleOfProgress

      minInput.toggleAttribute('targeted', isMinInputClosest)
      maxInput.toggleAttribute('targeted', !isMinInputClosest)
    }
  }

  handleNumberChange = (): void => {
    if (this.minNumberInput && this.maxNumberInput) {
      const minPrice = parseInt(this.minNumberInput.value)
      const maxPrice = parseInt(this.maxNumberInput.value)

      this.updateMinRangeInput(minPrice)
      this.updateMaxRangeInput(maxPrice)
    }
  }

  handleRangeChange = (): void => {
    if (this.minRangeInput && this.maxRangeInput) {
      const minVal = parseInt(this.minRangeInput.value)
      const maxVal = parseInt(this.maxRangeInput.value)

      this.updateMaxPriceInput(maxVal)
      this.updateMaxRangeInput(maxVal)

      this.updateMinPriceInput(minVal)
      this.updateMinRangeInput(minVal)
    }
  }

  updateMaxRangeInput(value: number): void {
    if (this.maxRangeInput && this.progress) {
      const rightPosition = 100 - (value / +this.maxRangeInput.max) * 100

      this.maxRangeInput.value = `${value}`

      this.progress.style.right = `${rightPosition}%`
    }
  }

  updateMinRangeInput(value: number): void {
    if (this.minRangeInput && this.progress) {
      const leftPosition = (value / +this.minRangeInput.max) * 100

      this.minRangeInput.value = `${value}`

      this.progress.style.left = `${leftPosition}%`
    }
  }

  updateMaxPriceInput(value: number): void {
    if (this.maxNumberInput) {
      this.maxNumberInput.value = value.toFixed(2)
    }
  }

  updateMinPriceInput(value: number): void {
    if (this.minNumberInput) {
      this.minNumberInput.value = value.toFixed(2)
    }
  }
}

export default PriceRange
